/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AbortSmartOnboardingResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    abortSmartOnboarding: build.mutation<AbortSmartOnboardingResponse, void>({
      query: () => ({
        body: undefined,
        method: 'POST',
        url: `/v1/onboarding/abort-smart-onboarding`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as abortSmartOnboardingApi };
export const { useAbortSmartOnboardingMutation } = injectedRtkApi;
